import {Hero, PageContainer} from "./Policy";

export const PrivacyPolicyPage = () => {
    return (<div className="min-h-screen bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-100">
            <Hero
                title="سیاست حریم خصوصی پلتفرم ونیفای"
                subtitle="ونیفای به حفظ حریم خصوصی کاربران اهمیت ویژه‌ای می‌دهد. این سیاست توضیح می‌دهد چگونه اطلاعات شما را جمع‌آوری، استفاده، ذخیره و محافظت می‌کنیم. با استفاده از خدمات، شما با این سیاست موافقت می‌کنید. لطفاً آن را مطالعه کنید."
            />


            <PageContainer>
                <h2 className="text-lg font-bold"> ۱. اطلاعات جمع‌آوری‌شده</h2>

                <p className="mb-2">
                    ما اطلاعات زیر را برای ارائه خدمات جمع‌آوری می‌کنیم:
                </p>


                <ul className="list-disc mt-3 list-inside ">


                    <li className="mb-2">
                        اطلاعات هویتی: کد ملی، اطلاعات هویتی، تصاویر چهره، ویدیوهای سلفی، اطلاعات حقوقی (مانند روزنامه رسمی هیئت مدیره).
                    </li>
                    <li className="mb-2">
                        اطلاعات فنی: IMEI دستگاه، IP آدرس، نوع دستگاه، لاگ‌های استفاده.
                    </li>
                    <li className="mb-2">اطلاعات استعلام: پلاک خودرو، جزئیات سند ملک، نتایج استعلام از مراجع رسمی (مانند پلیس راهور، قوه قضاییه، بانک‌ها).
                    </li>
                    <li className="mb-2">
                        اطلاعات پرداخت: جزئیات تراکنش‌ها (بدون ذخیره اطلاعات کارت).

                    </li>
                    <li className="mb-2">
                        اطلاعات ارتباطی: ایمیل، شماره تماس برای پشتیبانی.
                    </li>
                </ul>
                <p className="mt-4">
                    اطلاعات تنها با رضایت صریح یا الزام قانونی جمع‌آوری می‌شود.
                </p>

                <h2 className="text-lg mt-10 font-bold">۲. نحوه استفاده از اطلاعات</h2>

                <p className="mb-2">
                    اطلاعات برای اهداف زیر استفاده می‌شود:

                </p>


                <ul className="list-disc mt-3 list-inside ">


                    <li className="mb-2">
                        احراز هویت و تأیید هویت کاربران.
                    </li>
                    <li className="mb-2">
                        پردازش استعلام‌ها (مانند مالکیت خودرو/ملک، اعتبار معاملاتی، خوش‌حسابی بانکی، عدم سوءپیشینه).
                    </li>
                    <li className="mb-2">
                        بهبود خدمات (تحلیل ناشناس داده‌ها برای بهینه‌سازی).

                    </li>
                    <li className="mb-2">
                        پشتیبانی مشتری و اطلاع‌رسانی (مانند به‌روزرسانی‌ها).

                    </li>
                    <li className="mb-2">
                        رعایت الزامات قانونی (مانند گزارش به مراجع قضایی).

                    </li>
                </ul>
                <p className="mt-4">
                    ما اطلاعات را برای بازاریابی مستقیم استفاده نمی‌کنیم، مگر با رضایت جداگانه.
                </p>


                <h2 className="text-lg mt-10 font-bold">۳. اشتراک‌گذاری اطلاعات</h2>

                <ul className="list-disc mt-3 list-inside ">


                    <li className="mb-2">
                        با مراجع رسمی: اطلاعات برای استعلام‌ها به سازمان‌هایی مانند پلیس راهور، سازمان ثبت، قوه قضاییه ارسال می‌شود.
                    </li>
                    <li className="mb-2">
                        با تامین‌کنندگان: تنها با شرکای امن (مانند درگاه پرداخت) برای اجرای خدمات، و تحت قرارداد محرمانگی.
                    </li>
                    <li className="mb-2">
                        در موارد قانونی: اگر قانون الزام کند (مانند دستور قضایی یا پلیس فتا)، اطلاعات ارائه خواهد شد.
                    </li>
                    <li className="mb-2">
                        انتقال کسب‌وکار: در صورت ادغام یا فروش، اطلاعات با حفظ استانداردهای حریم خصوصی منتقل می‌شود.

                    </li>

                </ul>
                <p className="mt-4">
                    اطلاعات بدون رضایت شما به تبلیغ‌کنندگان یا اشخاص ثالث فروخته نمی‌شود.
                </p>
                <h2 className="text-lg mt-10 font-bold">
                    ۴. امنیت و ذخیره‌سازی
                </h2>

                <p className="mt-4">
                    اطلاعات با استفاده از رمزنگاری (مانند SSL) و فایروال‌ها محافظت می‌شود.
                    داده‌ها در سرورهای امن داخل ایران ذخیره می‌شوند و مدت نگهداری بر اساس ضرورت است.

                </p>


                <h2 className="text-lg mt-10 font-bold">
                    ۵. حقوق کاربران
                </h2>

                <p className="mt-2">
                    شما حق دارید:


                </p>

                <ul className="list-disc mt-3 list-inside ">


                    <li className="mb-2">
                        دسترسی به اطلاعات خود را درخواست کنید.
                        <br/>
                        درخواست‌ها از طریق پشتیبانی (01191012001) پردازش می‌شود.
                    </li>
                </ul>

                <h2 className="text-lg mt-10 font-bold">
                    ۶. کوکی‌ها و فناوری‌های مشابه
                </h2>

                <p className="mt-2">

                    از کوکی‌ها برای بهبود تجربه کاربری (مانند حفظ جلسه) استفاده می‌کنیم.
                    <br/>
                    می‌توانید کوکی‌ها را در تنظیمات مرورگر مدیریت کنید، اما این ممکن است برخی ویژگی‌ها را مختل کند.
                </p>


                <h2 className="text-lg mt-10 font-bold">
                    ۷. تغییرات در سیاست
                </h2>

                <p className="mt-2">
                    تغییرات از طریق وب‌سایت یا ایمیل اطلاع‌رسانی می‌شود.
                    <br/>
                    نسخه جدید بلافاصله لازم‌الاجرا است و ادامه استفاده به معنای پذیرش آن است.
                </p>

                <h2 className="text-lg mt-10 font-bold">
                    ۸. تماس با ما
                </h2>

                <p className="mt-2">
                    برای سؤالات، به شماره 01191012001 تماس بگیرید. ونیفای متعهد به شفافیت و احترام به حقوق شماست.
                    با تشکر از اعتماد شما به ونیفای.
                </p>


            </PageContainer>
        </div>);
};
export default PrivacyPolicyPage;